import { waLink } from "@/utils/whatsapp";
import { WhatsAppIcon } from "@/components/Footer";

export const WhatsAppButton = ({ message, children, className = "", testId = "whatsapp-button" }) => (
  <a
    href={waLink(message)}
    target="_blank"
    rel="noopener noreferrer"
    className={`inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-semibold text-white transition-all duration-200 hover:bg-[#1eb856] hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-700 focus-visible:ring-offset-2 ${className}`}
    data-testid={testId}
  >
    <WhatsAppIcon className="h-4 w-4" />
    {children}
  </a>
);
